import CustomTable from "components/common/CustomTable";
import SynthTooltip from "components/common/SynthTooltip";
import VendorAvatar from "components/common/VendorAvatar";
import { formatMoney, getCurrencyFromCurrencyCode } from "helpers";
import React from "react";

type TransferStockProps = {
    resultMessage: {
        message: string;
        summary: {
            transfers: Record<string, any>[];
            failed: number;
            successful: number;
            totalRequested: number;
        };
        success: boolean;
    };
    toolName: string;
};

const TransferStock = ({ resultMessage, toolName }: TransferStockProps) => {
    // console.log(resultMessage, "resultMessage transfer stock");

    const tableHeader = [
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Product name
                    </span>
                </div>
            ),
            widthClass: "w-[230px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Batch ID </span>
                </div>
            ),
            widthClass: "w-[133px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">SKU No. </span>
                </div>
            ),
            widthClass: "w-[83px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        From Warehouse
                    </span>
                </div>
            ),
            widthClass: "w-[150px] !border-r-none",
        },

        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        To Warehouse
                    </span>
                </div>
            ),
            widthClass: "w-[150px] ",
        },

        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Transfer Qty
                    </span>
                </div>
            ),
            widthClass: "w-[120px] ",
        },

        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Stock After (To)
                    </span>
                </div>
            ),
            widthClass: "w-[120px] ",
        },
    ];

    const result = resultMessage?.summary?.transfers?.flatMap((parent) =>
        parent?.result?.stocksTransferred?.map((item) => ({
            ...item,
            ...parent,
        }))
    );
    // console.log(result, "result");
    const tableBody = result?.map((item, idx) => {
        return [
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3">
                                {item?.inventory?.productImageDetails?.productImages?.[0] ? (
                                    <VendorAvatar
                                        imageSrc={
                                            item?.inventory?.productImageDetails?.productAvatar ||
                                            item?.inventory?.productImageDetails?.productImages?.[0]
                                        }
                                        size={32}
                                        name={item?.inventory?.productName}
                                        containerClassname="!rounded-md"
                                    />
                                ) : (
                                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                    </div>
                                )}
                                <p className="break-all">{item?.inventory?.productName || ""}</p>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2 break-all`}
                    >
                        <div>
                            <p className="">{item?.batchId || "N/A"}</p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2 break-all`}
                    >
                        <div>
                            <p className=" ">{item?.inventory?.sku || "N/A"}</p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">{item?.fromWarehouse}</p>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">{item?.toWarehouse}</p>
                    </div>
                ),
                widthClass: " !border-b",
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">{`${item?.quantity} ${
                            item?.inventory?.productStockDetails?.unitOfMeasurement || ""
                        }`}</p>
                    </div>
                ),
                widthClass: " !border-b",
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className=""></p>
                    </div>
                ),
                widthClass: " !border-b",
            },
        ];
    });
    return (
        <div>
            {resultMessage?.success && resultMessage?.summary?.transfers?.length > 0 && (
                <div>
                    <CustomTable
                        tableBody={tableBody}
                        tableHeader={tableHeader}
                        isCellBordered={true}
                        stickyHeader={true}
                        headerContainerClass="!bg-slate-50 "
                        headerItemClass="font-rocGroteskMedium "
                        tableClass="mb-4"
                        isScrollable={true}
                        scrollWithin={true}
                        renderEmptyTable={() => null}
                    />
                </div>
            )}
        </div>
    );
};

export default TransferStock;
